// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","size":"125px","ingredient":"G010fe9 Ge743c3","imageContainer":"G78a343","label":"G356136 G50d90f Gd71c60 G42bbcd Gd6fd01"};